module.exports = __webpack_public_path__ + "static/media/man.247693a1.png";